import { render, staticRenderFns } from "./ResultsTabCome.vue?vue&type=template&id=ebb5a97e&lang=pug&"
import script from "./ResultsTabCome.vue?vue&type=script&lang=js&"
export * from "./ResultsTabCome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports